import React from "react";
import Flx from "./Flx";

const Screen = ({ children, id, background = "transparent", sx }) => {
  return (
    <Flx id={id} column sx={{ height: "100%", background, ...sx }}>
      {children}
    </Flx>
  );
};

export default Screen;
